import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

/**
 * Firebase Web app inicializācija. Konfigurācija nāk no .env.local
 * (sk. .env.example par formātu). Lieto to pašu projektu kā Android lietotne -
 * tāpēc id token verificējams ar to pašu FirebaseAuthenticationHandler serverī.
 */
const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

if (!firebaseConfig.apiKey) {
    throw new Error(
        'Firebase konfigurācija nav iestatīta. Kopē .env.example uz .env.local un aizpildi.',
    );
}

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
